<template>
  <div>
    <input :value="Longitude" type="hidden" name="Longitude" id="Longitude" />
    <input :value="Latitude" type="hidden" name="Latitude" id="Latitude" />
    <gmap-map @click="clicked" :center="center" :zoom="8" style="width:100%;  height: 400px;">
      <gmap-marker :position="marker.position" @click="center=markers.position"></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  data() {
    return {
      center: this.passedMarkers.position || {
        lat: 23.2256959,
        lng: 42.3730331
      },
      marker: this.passedMarkers,
      places: [],
      Longitude: "",
      Latitude: "",
      currentPlace: null
    };
  },
  props: {
    clickable: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    passedMarkers: {
      type: Object,
      default: () => {
        return { position: { lat: 0, lng: 0 } };
      }
    }
  },

  mounted() {
    //this.geolocate();
  },

  methods: {
    clicked(e) {
      if (!this.$props.clickable) return;
      this.Longitude = e.latLng.lng();
      this.Latitude = e.latLng.lat();
      this.$emit("updateLocation", this.Latitude, this.Longitude);
      this.setMarker(this.Latitude, this.Longitude);
    },
    setMarker(lat, lng) {
      this.marker = {
        position: {
          lat,
          lng
        }
      };
    }
  },
  geolocate: function() {
    navigator.geolocation.getCurrentPosition(position => {
      this.center = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
    });
  }
};
</script>

<style scoped>
</style>